import { render, staticRenderFns } from "./OpenaiConversation.vue?vue&type=template&id=a5f39d20&scoped=true"
import script from "./OpenaiConversation.vue?vue&type=script&lang=js"
export * from "./OpenaiConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f39d20",
  null
  
)

export default component.exports